import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../Sidebar";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import DoctorHeader from "../../../doctor/DoctorHeader";
import apiClient from "../../../utils/apiClient";

const StudyTimeline = () => {
  const { id } = useParams("id");
  const [studyStatus, setStudyStatus] = useState(null);
  // const studyData = [
  //   {
  //     date: "20 Oct 2022",
  //     time: "5.50 PM",
  //     name: "Anshuman",
  //     role: "Sub admin",
  //     heading: "Uploaded the study report and assign study to radiologist",
  //     description: "All good",
  //     status: true,
  //   },
  //   {
  //     date: "21 Oct 2022",
  //     time: "5.50 PM",
  //     name: "Anshuman",
  //     role: "Site person",
  //     heading: "Uploaded the study report and assign study to radiologist",
  //     description: "All good",
  //     status: true,
  //   },
  //   {
  //     date: "22 Oct 2022",
  //     time: "5.50 PM",
  //     name: "Anshuman",
  //     role: "Radiologist",
  //     heading: "Uploaded the study report and assign study to radiologist",
  //     description: "",
  //     status: true,
  //   },
  //   {
  //     date: "23 Oct 2022",
  //     time: "5.50 PM",
  //     name: "Anshuman",
  //     role: "Quality checker",
  //     heading: "Uploaded the study report and assign study to radiologist",
  //     description: "All good",
  //     status: false,
  //   },
  //   {
  //     date: "24 Oct 2022",
  //     time: "5.50 PM",
  //     name: "Anshuman",
  //     role: "Sub admin",
  //     heading: "Uploaded the study report and assign study to radiologist",
  //     description: "",
  //     status: false,
  //   },
  // ];
  const fetchStatus = async () => {
    try {
      const response = await apiClient.get(`studyStatus?studyId=${id}`);
      const data = response.data.StudyStatus.data;

      const status = data.map((item) => {
        const studyInfo = {};
        const date = new Date(item.created_date_time);
        const formattedDate = date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        const formattedTime = date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });

        studyInfo.date = formattedDate;
        studyInfo.time = formattedTime;

        // Handle roleSitePerson
        if (item.roleSitePerson) {
          studyInfo.name = item.roleSitePerson.name;
          studyInfo.role = "Site Person";
          studyInfo.status = item.status;
          // studyInfo.description = `uploaded the study. --- status: ${item.status}`;
          studyInfo.description = (
            <p style={{ fontSize: "14px", color: "black" }}>
              uploaded the study
              <br></br> status :{" "}
              <b className="text-capitalize">
                {" "}
                {item.status == "read" ? "pending" : item.status}
              </b>
            </p>
          );
        }

        // Handle roleRadiologist
        if (
          item.roleSubAdmin &&
          item.roleRadiologist &&
          item.status === "assigned"
        ) {
          studyInfo.name = item.roleSubAdmin.name;
          studyInfo.role = "Admin";
          studyInfo.status = item.status;
          studyInfo.description = (
            <p style={{ fontSize: "14px", color: "black" }}>
              Admin/SuperAdmin assigned it to <b>{item.roleRadiologist.name}</b>
              <br></br> status :{" "}
              <b className="text-capitalize">
                {" "}
                {item.status == "read" ? "pending" : item.status}
              </b>
            </p>
          );
        }

        if (
          (item.roleRadiologist || item.roleQualityChecker) &&
          item.status === "read"
        ) {
          studyInfo.name = item.roleRadiologist
            ? item.roleRadiologist.name
            : item.roleQualityChecker.name;
          studyInfo.role = item.roleRadiologist
            ? "Radiologist"
            : "Quality Checker";
          studyInfo.status = item.status;
          // studyInfo.description = `checked the study and created a report. --- status: ${item.status}`;
          studyInfo.description = (
            <p style={{ fontSize: "14px", color: "black" }}>
              Reviewed the study, provided remarks, and created a report
              <br></br> status :{" "}
              <b className="text-capitalize">
                {" "}
                {item.status == "read" ? "pending" : item.status}
              </b>
            </p>
          );
        }

        if (
          item.roleSubAdmin &&
          item.roleQualityChecker &&
          item.status === "read"
        ) {
          studyInfo.name = item.roleSubAdmin.name;
          studyInfo.role = "Admin";
          studyInfo.status = item.status;
          // studyInfo.description = ` Superadmin/Subadmin assigned it to ${item.roleQualityChecker.name} for review. ---Status: ${item.status}`;
          studyInfo.description = (
            <p style={{ fontSize: "14px", color: "black" }}>
              Superadmin/Subadmin assigned it to{" "}
              <b>{item.roleQualityChecker.name}</b>
              <br></br> status :{" "}
              <b className="text-capitalize">
                {" "}
                {item.status == "read" ? "pending" : item.status}
              </b>
            </p>
          );
        }

        // Handle roleQualityChecker
        if (
          (item.roleQualityChecker && item.status === "revise") ||
          item.status == "final"
        ) {
          studyInfo.name = item.roleQualityChecker.name;
          studyInfo.role = "Quality Checker";
          studyInfo.status = item.status;
          // studyInfo.description = ` Reviwed the study and transferred it to the sub-admin.  status---: ${item.status}`;
          studyInfo.description = (
            <p style={{ fontSize: "14px", color: "black" }}>
              Reviewed the study and marked it as either accepted or requiring
              revision. <br></br> status :{" "}
              <b className="text-capitalize">
                {" "}
                {item.status == "read" ? "pending" : item.status}
              </b>
            </p>
          );
        }

        return studyInfo;
      });

      setStudyStatus(status);
    } catch (error) {
      console.error("Error fetching study status:", error);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  console.log("studyStatus---->", studyStatus);
  return (
    <>
      <div className="main-wrapper">
        <DoctorHeader />
        <Sidebar activeClassName="invoice-report" />
        <div className="page-wrapper">
          <div className="content">
            <h2 className="studies_cus">Study Flow</h2>
            {studyStatus?.map((data, index) => (
              <div className="row" key={index}>
                {" "}
                {/* Added key prop for list items */}
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="activity">
                        <div className="activity-box">
                          <ul className="activity-list">
                            <li>
                              <div className="activity-user">
                                <Link
                                  to="#"
                                  title={data.name}
                                  data-bs-toggle="tooltip"
                                  className="avatar"
                                >
                                  {data.status ? (
                                    <CheckCircleIcon sx={{ color: "green" }} />
                                  ) : (
                                    <PendingIcon sx={{ color: "blue" }} />
                                  )}
                                </Link>
                              </div>
                              <div className="activity-content timeline-group-blk">
                                <div className="timeline-group flex-shrink-0">
                                  <h3>{data.role}</h3>
                                  <h5>{data.date}</h5>
                                  <span className="time">{data.time}</span>
                                </div>
                                <div className="comman-activitys flex-grow-1">
                                  <h3>
                                    {data.name}
                                    <span>{data.heading}</span>
                                  </h3>
                                  <p
                                    style={{ fontSize: "14px", color: "black" }}
                                  >
                                    {data.description}
                                  </p>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default StudyTimeline;
